import { render, staticRenderFns } from "./RWMData.vue?vue&type=template&id=53510bf1&"
import script from "./RWMData.vue?vue&type=script&lang=js&"
export * from "./RWMData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports